import { render, staticRenderFns } from "./PlayerTags.vue?vue&type=template&id=5232f8e4&"
import script from "./PlayerTags.vue?vue&type=script&lang=ts&"
export * from "./PlayerTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports